export default __webpack_public_path__ + "static/media/agency-logo.1f47b373.svg";